import { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { UserContext } from '../Context/UserContext';
import { sentryLog } from '../Utils/SentryLog';
import HamburgerIcon from '../Icons/HamburgerIcon';
import HomeIcon from '../Icons/HomeIcon';
import { getLqzyParams } from '../Utils/GetLqzyParams';
/* global gtag */

const lemonSqzyQueryParams = getLqzyParams();

const affiliateSignupUrl = "https://easyimagetotext.lemonsqueezy.com/affiliates";

function Navbar({ setShowFeedbackPopup, isMobileMenuOpen, setIsMobileMenuOpen, isNewUser=false }){

    const { isLoggedIn, user } = useContext(UserContext);

    const isPremiumUser = user ? user.isPremium : false;

    const isShowConsole = process.env.NODE_ENV === 'development';

    const location = useLocation();
    const navigate = useNavigate();
    isShowConsole && console.log("Current Path:", location.pathname); 

    const API_BASE_URL = process.env.NODE_ENV === 'development' 
    ? process.env.REACT_APP_LOCAL_API_URL 
    : process.env.REACT_APP_API_URL;

    const navigateToHome = e => {
        navigate(`/${lemonSqzyQueryParams}`);
    }

    const initiateLogin = async () => {
        //event tracker
            gtag('event', 'login_clicked', {
                event_category: 'Button',
                event_label: 'Login'
            });
        //
        try{
            await fetch(`${API_BASE_URL}/api/session-init`, {
                method: 'GET',
                credentials: 'include'
              });
            window.location.href = `${API_BASE_URL}/auth/google`;
        }catch(err){
            isShowConsole && console.error('error in initiate login method: ', err);
            sentryLog(`Navbar.js - initiateLogin failed: ${err?.message || err}`);
        }
    }

    const openUserAccountPage = e => {
        try{
            navigate(`/user-account${lemonSqzyQueryParams}`);
        }catch(err){
            isShowConsole && console.error('error in openUserAccountPage method: ', err);
            sentryLog(`Navbar.js - openUserAccountPage failed: ${err?.message || err}`);
        }
    }
    
    const openPricingPage = e => {
        //event tracker
            gtag('event', 'pricing_clicked', {
                event_category: 'Button',
                event_label: 'Pricing'
            });
        //
        try{
            navigate(`/pricing${lemonSqzyQueryParams}`);
        }catch(err){
            isShowConsole && console.error('error in openPricingPage method: ', err);
            sentryLog(`Navbar.js - openPricingPage failed: ${err?.message || err}`);
        }
    }

    const openAffiliatePage = e => {
        //event tracker
            gtag('event', 'affiliate_clicked', {
                event_category: 'Button',
                event_label: 'Affiliate'
            });
        //
        try{
            navigate(`/affiliate${lemonSqzyQueryParams}`);
        }catch(err){
            isShowConsole && console.error('error in openAffiliatePage method: ', err);
            sentryLog(`Navbar.js - openAffiliatePage failed: ${err?.message || err}`);
        }
    }

    const initiateAffiliateSignup = e => {
        //event tracker
            gtag('event', 'affiliate_clicked', {
                event_category: 'Button',
                event_label: 'Affiliate'
            });
        //
        try{
            window.open(affiliateSignupUrl, '_blank', 'noopener,noreferrer');
        }catch(err){
            console.log('error in initiateAffiliateSignup method: ', err);
            
        }
    }

    const handleHamburgerClick = e => {
        try{
            setIsMobileMenuOpen(!isMobileMenuOpen);
        }catch(err){
            isShowConsole && console.error('error in handleHamburgerClick method: ', err);
            sentryLog(`Navbar.js - handleHamburgerClick failed: ${err?.message || err}`);
        }
    }

    const handleHelpClick = e => {
        try{
            navigate(`/contact-us${lemonSqzyQueryParams}`);
        }catch(err){
            isShowConsole && console.error('error in handleHelpClick method: ', err);
            sentryLog(`Navbar.js - handleHelpClick failed: ${err?.message || err}`);
        }
    }

    const handleHomeClick = e => {
        try{
            navigate(`/${lemonSqzyQueryParams}`);
        }catch(err){
            isShowConsole && console.error('error in handleHomeClick method: ', err);
            sentryLog(`Navbar.js - handleHomeClick failed: ${err?.message || err}`);
        }
    }

    const isHomeScreen = location.pathname === '/' || location.pathname === '/handwriting-ocr';
    isShowConsole && console.log('is home screen: ', isHomeScreen);

    return(
        <>
            <div className="navbarCont">
                <div className="logoDiv" onClick={navigateToHome}>
                    <img src={'/app logo.gif'} alt='app logo'/>
                </div>
                {isHomeScreen ? 
                    <div className="navigationDiv">
                        <div className='newUserAffiliate' onClick={initiateAffiliateSignup}>Share & Earn</div>
                        {/* <div><a href='#use-cases'>Use Cases</a></div> */}
                        {/* <div><a href='#why-this-app'>Why this App</a></div> */}
                        <div><a href='#how-it-works'>How It Works</a></div>
                        <div><a href='#faq'>FAQs</a></div>
                        <div className='helpBtn' onClick={handleHelpClick}>{isNewUser ? "Contact Us" : "Help ?"}</div>
                        {isNewUser && <div className='newUserPricing' onClick={openPricingPage}>Pricing</div>}
                    </div> :
                    <div className="navigationDiv notHome">
                        <div><Link to="/"><span>Return to Home</span></Link></div>
                    </div>
                }
                {!isNewUser && <div className='userActionCont'>
                    {(user !== undefined && user?.planType !== 'Lifetime') && (<div className='pricingDiv'>
                            <div className='pricingBtn' onClick={openPricingPage}>
                                Pricing
                            </div>
                        </div>)}
                    {(user !== undefined) && 
                        <div className='loginAcctDiv'>
                            {isLoggedIn ? 
                                <div className='accountDiv' onClick={openUserAccountPage}>
                                    <div className='welcome'>
                                        <div className='greeting'>Hello, {user.name}</div>
                                    </div>
                                    <div className='accountBtn'>
                                        Account
                                    </div>
                                </div> : 
                                <div className='loginDiv' onClick={initiateLogin}>
                                    Login
                                </div>
                            }
                        </div>
                    }
                </div>}
                {isHomeScreen ? 
                    <div className='hamburgerDiv' onClick={handleHamburgerClick}>
                        <HamburgerIcon stroke='white'/>
                    </div> : 
                    <div className='homeDiv' onClick={handleHomeClick}>
                        <HomeIcon fillColor='white'/>
                    </div>
                }
            </div>
            {isMobileMenuOpen && <div className='mobileNavMenu'>
                <div className='menuWrapper'>
                    <div className="navigationDiv">
                        <div className='newUserAffiliate' onClick={initiateAffiliateSignup}>Affiliate</div>
                        {/* <div><a href='#why-this-app'>Why this App</a></div> */}
                        <div className='helpBtn' onClick={handleHelpClick}>{isNewUser ? "Contact Us" : "Help ?"}</div>
                        {/* <div><a href='#use-cases'>Use Cases</a></div> */}
                        <div><a href='#how-it-works'>How It Works</a></div>
                        <div><a href='#faq'>FAQs</a></div>
                    </div>
                    <div className='userActionCont'>
                        {(user !== undefined) && (user?.planType === 'Lifetime' ? (<div className='pricingDiv'>
                            <div className='pricingBtn' onClick={() => setShowFeedbackPopup(true)}>
                                Feedback?
                            </div>
                        </div>) : (<div className='pricingDiv'>
                            <div className='pricingBtn' onClick={openPricingPage}>
                                Pricing
                            </div>
                        </div>))}
                        {(user !== undefined) && 
                            <div className='loginAcctDiv'>
                                {isLoggedIn ? 
                                    <div className='accountDiv' onClick={openUserAccountPage}>
                                        {/* <div className='welcome'>
                                            <div className='greeting'>Hello, {user.name}</div>
                                        </div> */}
                                        <div className='accountBtn'>
                                            Account
                                        </div>
                                    </div> : 
                                    <div className='loginDiv' onClick={initiateLogin}>
                                        Login
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </div>
            </div>}
        </>
    )
}

export default Navbar;